var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-button"},[_c('div',{staticClass:"select-button__select"},[_vm._t("select")],2),_c('div',{staticClass:"select-button__button"},[_vm._t("button")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }